import MovieContainer from './MovieContainer'
import MovieDetailContainer from './MovieDetailContainer'
import StarDetailContainer from './StarDetailContainer'
import SearchBarContainer from './SearchBarContainer'

export {
  MovieContainer,
  MovieDetailContainer,
  StarDetailContainer,
  SearchBarContainer,
}



// WEBPACK FOOTER //
// ./src/containers/index.js